import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Toast } from 'antd-mobile';
import { connect } from 'dva';
import { unionFlag, getSessonStorage, checkUnifyShop } from '@/utils';
import OrderHead from '@/components/OrderHead';
import Icon from '@/components/Icon';
import Api from '@/common/api';
import DfPrice from '@/components/dFPrice';
import rule from '@/utils/rule';
import SMSAPI from '@/entity/module/vertifyCode';
import { getMovieSessionInfoStr, getMovieSessionInfoTimeStr, parseDate, timeToHm } from '@/utils/time';
import styles from './index.less';
import closeImg from '@/assets/imgs/close.png';
import supportRefundImg from '@/assets/imgs/order/order_right_refund.png';
import errorRefundImg from '@/assets/imgs/order/order_error_refund.png';
import refundRightArrow from '@/assets/imgs/order/order_right_arrow.png';
import refundTips from '@/assets/imgs/order/refund-tips.png';
import { TLang, ReplaceText, getCookie, CheckCN } from '@/utils/lang';
import { router } from 'umi';
import PurchaseLimitModal from '@/components/purchaseLImitModal';
import api from '@/common/api';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import { safeJsonParse } from '@/utils/safeJsonParse';

const OrderComfirm = (props: any) => {
  // toggle 商城/百福得
  const unionCode = unionFlag() || getSessonStorage('dffl_union');
  // true 百福得
  const [union] = useState(unionCode && typeof unionCode !== 'undefined');

  const [dataSource, setDataSource] = useState<any>(null);
  const [mobile, setMobile] = useState('');
  const [code, setCode] = useState('');
  const [tipsText, setTipsText] = useState(TLang('请核实订单信息确认无误后下单', 'home', false, false, null));
  const [tipsContent, setTipsContent] = useState<any>();
  // 倒计时
  const [count, setCount] = useState(60);
  // 明细
  const [showDetailModal, setShowDetailModal] = useState(false);
  // 信息确认
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  // 信息核实弹框
  const [level2ConfirmModal, setLevel2ConfirmModal] = useState(false);
  // 是否发送 (功能留着百福得备用)
  const [send, setSend] = useState(false);
  //
  const [errorMsg, setErrorMsg] = useState('');
  const [errorFlag, setErrorFlag] = useState(false);
  const [refundInstructionsModal, setRefundInstructionsModal] = useState(false); //退票须知

  // 限购弹框
  const [purchaseLimitModal, setPurchaseLimitModal] = useState(false);
  const [purchaseLimitInfo, setPurchaseLimitInfo] = useState({});
  const [companyOrderType, setCompanyOrderType] = useState(2);
  const [aggOrderH5Url, setAggOrderH5Url] = useState('');

  useEffect(() => {
    let cityId = 145;
    const localAddress = safeJsonParse(DFWebUtilsTools.getCatchAddress());
    const address = getSessonStorage('currentAddress');
    if (address) {
      cityId = localAddress && localAddress?.cityId ? localAddress?.cityId : JSON.parse(address).cityId;
    }
   if (unionCode||checkUnifyShop()) {
    api.findByUnionConfig({ union: unionCode, city: cityId, channel:1, ignore: false, unionFlag: union ? 1 : 0}).then((res) => {
      console.log('findByUnionConfig', res);
      if (res) {
        setCompanyOrderType(res.companyOrderType);
        setAggOrderH5Url(res.aggOrderH5Url);
      }
    });
   }
  }, []);

  useEffect(() => {
    // 百福德

    const orderSn = props.location.query.orderSn;
    Api.getOrderConfirmDetail({ orderSn }).then((res) => {
      setDataSource(res);
      sessionStorage.setItem('refundRuleExplain', JSON.stringify(res?.refundRuleExplain));
      if (res.mobile) {
        setMobile(res.mobile);
      }
    });
  }, []);
  const mobileChangeHandle = (e) => {
    setMobile(e.target.value);
  };
  const codeChangeHandle = (e) => {
    let value = e.target.value;
    if(value.length > 6) {
      value = value.slice(0, 6); // 解决IOS系统验证码被填充两遍的问题
    }
    setCode(value);
  };
  const sendCodeHandle = async () => {
    if (mobile && mobile.length !== 11) {
      return Toast.info(TLang('请填写11位手机号', 'home', false, false, null));
    }
    try {
      // 使用 await 调用，添加 try-catch 处理图形验证码弹窗关闭
      const res = await SMSAPI.getVerificationCode({ mobile: mobile });
      if(res){
        Toast.info(TLang('验证码发送成功', 'home', false, false, null));
        setSend(true);
        setCount(60);
      }
    } catch (error) {
      // 用户关闭验证码弹窗或验证失败，不执行后续逻辑
      console.log('验证码发送取消或失败', error);
    }
  };
  useEffect(() => {
    let timer;

    if (send && typeof timer === 'undefined') {
      if (count === -1) {
        // setSend(false)
        send && timer && clearTimeout(timer);
        timer = null;
      } else {
        timer = setTimeout(() => {
          setCount(count - 1);
          timer = null;
        }, 1000);
      }
    }
    return () => {
      send && timer && clearTimeout(timer);
    };
  }, [send, count]);

  const toggleShowModelHandle = () => {
    setShowDetailModal(!showDetailModal);
  };
  const confirmOrderHandle = () => { // /newpayment?city=145&order_sn=2160058336790764957
    setShowConfirmModal(false);
    // req api & to other page
    // 	/order/confirm 接口
    const sn = props.location.query.orderSn;
    // 提交订单。 百福得增加手机号。
    Api.getOrderConfirm(sn, mobile).then((res) => {
      if (res.Status !== 0 && res.Message) {
        setErrorMsg(res.Message);
        setErrorFlag(true);
      } else if (res.Data) {// url
        // router.replace('/order')
        if (res.Data?.purchaseLimitDTO.isGrey && !res.Data?.purchaseLimitDTO?.passFlag) {
          setPurchaseLimitInfo(res.Data?.purchaseLimitDTO);
          setPurchaseLimitModal(!res.Data?.purchaseLimitDTO?.passFlag);
        } else {
          sessionStorage.removeItem('movie-seat-orderSn-h5');
          window.df_sdk_common.location.href = res.Data.paymentUrl.indexOf('http') === 0 ? res.Data.paymentUrl : '//' + res.Data.paymentUrl;
        }
      }
    });
  };
  // const {navText,noticeText,bgImg, movieImg,movieName,movieInfo,cinemaName,seatInfo,otherAlert,alert} = props;

  const getMovieInfoStrForModal = (): string => {
    let t = parseDate(dataSource.showDateTime);
    let day: Array<string> = t.date.split('-');
    let t3 = timeToHm(dataSource.showDateTime);
    return `${t.label} ${day[0]}${TLang('月', 'home', false, false, null)}${day[1]}${TLang('日', 'home', false, false, null)} ${t3}`;
  };
  const getSeatInfoStr = (): string => {
    let str = dataSource.hallName;
    dataSource.seatList.forEach((itemArr) => {
      itemArr.forEach((item) => {
        str += ` ${item.seatDesc}`;
      });
    });
    return str;
  };
  const isWidth = useMemo(() => getCookie('df_lang') === 'en-US' && dataSource?.totalPrice.toString().length >= 5, [dataSource?.totalPrice]);

  const getTipsMsg = () => {
    if (!dataSource?.showDateTime) {
      return '';
    }
    const lastTime = dataSource?.showDateTime.replace(/-/g, '/').replace(/T/, ' ');
    const lastDate = new Date(lastTime);
    const nowDate = new Date();
    const dateDiff = lastDate.getTime() - nowDate.getTime();//时间差的毫秒数
    const minutes = Math.floor(dateDiff / (60 * 1000));//计算相差分钟数
    if (minutes <= 15 && minutes > 0) {
      setTipsText(TLang('临近开场的场次出票时间较长且出票失败率高，请确认无误后下单', 'home', false, false, null));
      setTipsContent(<><span style={{ color: '#333333' }}>{TLang('将在', 'home', false, false, null)}</span>{minutes}{TLang('分钟', 'home', false, false, null)}<span style={{ color: '#333333' }}>{TLang('后开场', 'home', false, false, null)}</span></>);
      return;
    }
    setTipsText(TLang('请核实订单信息确认无误后下单', 'home', false, false, null));
    setTipsContent('');
  };

  const submitBtnHandle = () => {
    getTipsMsg();
    // 已绑定手机用户，无需发送验证码，showVerifyCode控制
    if (union && !checkUnifyShop() && !!dataSource?.showVerifyCode) {
      if (mobile && mobile.length !== 11) {
        return Toast.info(TLang('请填写11位手机号', 'home', false, false, null));
      } else if (code.length === 0) {
        return Toast.info(TLang('请填写验证码', 'home', false, false, null));
      }
      SMSAPI.verifyVerificationCode({ mobile: mobile, verificationCode: code }).then((res) => {
        if (res) {
          setShowDetailModal(false);
          if(dataSource?.isVendor2 === 1) {
            setLevel2ConfirmModal(true);
          } else {
            setShowConfirmModal(true);
          }
        }

      });
    } else {
      setShowDetailModal(false);
      if(dataSource?.isVendor2 === 1) {
        setLevel2ConfirmModal(true);
      } else {
        setShowConfirmModal(true);
      }
    }

  };

  return <div className={`${styles.orderComfirmWrapper} bottom-button`}>
    {
      dataSource ? <>

        <OrderHead navText={TLang('确认订单', 'home', false, false, null)}
          cinemaNotice={dataSource.cinemaNotice}
          movieImg={dataSource.movieLogo}
          movieName={dataSource.movieName}
          movieInfo={getMovieSessionInfoStr(dataSource)}
          cinemaName={dataSource.cinemaName}
          showTag={dataSource.showTag}
          ticketChangeDesc={dataSource.ticketChangeDesc}
          supportChange={dataSource.supportChange}
          supportRefund={dataSource.supportRefund}
          refundTagExplain={dataSource.refundTagExplain}
          isVendor2={dataSource?.isVendor2}
          seatInfo={getSeatInfoStr()}
          movieNotice={dataSource.movieNotice}
          setRefundInstructionsModal={setRefundInstructionsModal}
        >
          <div className={styles.mobileWrapper}>
            {
              // 已绑定手机用户，无需发送验证码，showVerifyCode控制
              (union && !checkUnifyShop()) && !!dataSource?.showVerifyCode ?
                <>
                  <div>
                    <input type="text" style={{ width: '100%' }} maxLength={11} placeholder={TLang('填写取票手机号', 'home', false, false, null)} value={mobile} onChange={mobileChangeHandle} />
                  </div>
                  <div>
                    <input type="text" style={{ width: '120px' }} placeholder={TLang('请填写验证码', 'home', false, false, null)} value={code} onChange={codeChangeHandle} />
                    {
                      send && (count < 60 && count >= 0) ?
                        <span className={styles.timeout}>{count}s</span> :
                        <span style={{ marginTop: '5px' }} className={styles.btn} onClick={sendCodeHandle}>{send ? TLang('重新发送', 'home', false, false, null) : TLang('发送验证码', 'home', false, false, null)}</span>
                    }
                  </div>
                </>
                : <div>
                  <span>{TLang('取票手机号', 'home', false, false, null)}</span>
                  <span>{mobile}</span>
                </div>
            }
          </div>
          <div className={`${styles.bottomWrapper} ${showConfirmModal || refundInstructionsModal || errorFlag || purchaseLimitModal ? styles.showCf : ''}`}>
            {dataSource?.mallGrayScale === 0 && dataSource?.mallSource == 1 && <div className={styles.serviceTip}>本单可能收取平台服务费，以支付页为准</div>}
            <div className={styles.priceWrapper}>
              <span style={{ display: 'inline-block', whiteSpace: 'pre-wrap', width: isWidth ? '40px' : 'auto' }}>{TLang('需支付', 'home', false, false, null)}</span>
              <DfPrice price={dataSource.totalPrice} iconCls="gw" textStyles={{ 'fontSize': '0.36rem', 'fontWeight': '500', 'color': '#F44545' }} />
              {/* <b/>
            <span>{toPrice(dataSource.totalPrice)}</span> */}
              <div onClick={toggleShowModelHandle} className={styles.desc}>
                {TLang('明细', 'home', false, false, null)}
                <Icon
                  type="order_selectdate_more"
                  size="xxs"
                  color="#B2B2B2"
                  className={`${showDetailModal ? styles.rota : styles.nor}`}
                />
              </div>
            </div>
            <div className={styles.subBtn} onClick={submitBtnHandle}>{TLang('提交订单', 'home', false, false, null)}</div>
          </div>

        </OrderHead>
      </> : null
    }
    <PurchaseLimitModal
      setPurchaseLimitModal={setPurchaseLimitModal}
      purchaseLimitModal={purchaseLimitModal}
      purchaseLimitInfo={purchaseLimitInfo}
      pageSource="order"
      companyOrderType={companyOrderType}
      union={union}
      unionCode={unionCode}
      aggOrderH5Url={aggOrderH5Url}
    />
    <Modal
      popup
      visible={showDetailModal}
      onClose={() => setShowDetailModal(false)}
      animationType="slide-up"
      className="seatDesc"
      wrapClassName="seat-wrap"
    >
      <div className="seatModalWrapper">
        <div className="modalHeader">{TLang('支付明细', 'home', false, false, null)}
          <img src={closeImg} alt="" onClick={() => setShowDetailModal(false)} />
        </div>
        <div className="modalSectionHeader">{TLang('票品详情', 'home', false, false, null)}</div>
        <ul className="modalSectionContent">
          {
            dataSource && dataSource.seatList && dataSource.seatList.map((itemArr, index) => itemArr.map((item, idx) => <li key={`${index}-${idx}`}>
              <span>{item.seatDesc}</span>
              {/* <span>{toPrice(item.price)}</span> */}
              <DfPrice price={item.price} showIcon={false} textStyles={{ 'fontSize': '0.28rem', 'fontWeight': '400', 'color': '#000' }} />
            </li>))
          }
        </ul>
      </div>
    </Modal>
    <Modal
      visible={showConfirmModal}
      transparent
      maskClosable
      onClose={() => setShowConfirmModal(false)}
      title={TLang('信息核实', 'home', false, false, null)}
      className="confirm-info-modal"
      wrapClassName="conform-wrap"
    >
      {
        dataSource && dataSource.seatList ? <div className="content">
          <div className="desc">
            <p>{TLang('您选择的是', 'home', false, false, null)}<span>{getMovieInfoStrForModal()}</span>{TLang('的场次', 'home', false, false, null)}，<span>{tipsContent}</span><br />
              {/* TODO:是否可以退换的字段由接口提供 */}
              <span>
                {/* {dataSource?.refundDesc} */}
                {TLang(dataSource?.refundDesc, 'home', false, false, null)}
              </span>
              {dataSource?.refundDesc && <span>、</span>}
              <span>
                {/* {dataSource?.refundDesc} */}
                {TLang(dataSource?.ticketChangeDesc, 'home', false, false, null)}
              </span>
            </p>
            {/* <p className="otherAlert">{dataSource.alert||'票品一经售出 不支持退款'}</p> */}
            {/* {
              dataSource?.refundDesc && <p className="otherAlert">{dataSource?.refundDesc}</p>
            } */}
            <p className="otherAlert">{tipsText}</p>
          </div>
          <div className="footer">
            <div className="cancle" onClick={() => setShowConfirmModal(false)}>{TLang('再看看', 'home', false, false, null)}</div>
            <div className="confirm" onClick={() => confirmOrderHandle()}>{TLang('确认提交', 'home', false, false, null)}</div>
          </div>
        </div> : null
      }
    </Modal>
    <Modal
      visible={level2ConfirmModal}
      transparent
      maskClosable
      prefixCls="level2Confirm"
      onClose={() => setLevel2ConfirmModal(false)}
      title={TLang('请确认购票信息', 'home', false, false, null)}
      className={styles['confirm-levelInfo-modal']}
      wrapClassName={styles['conform-levelWrap']}
    >
      <div className={styles.content}>
        <div className={styles.desc}>
          <div className={styles.infoItem}>
            <div className={styles.left}>{TLang('时间', 'home', false, false, null)}</div>
            <div className={styles.right}>{getMovieSessionInfoTimeStr(dataSource)}</div>
          </div>
          <div className={styles.infoItem}>
            <div className={styles.left}>{TLang('影院', 'home', false, false, null)}</div>
            <div className={styles.right}>{dataSource?.cinemaName}</div>
          </div>
          <div className={styles.infoItem}>
            <div className={styles.left}>{TLang('座位', 'home', false, false, null)}</div>
            <div className={styles.right}>
              <div className={styles.hallName}>{dataSource?.hallName}</div>
              <div className={styles.seats}>
                {
                Array.isArray(dataSource?.seatList) ? dataSource?.seatList.map((item) => item.map(((i) => <div className={styles.seat} key={i.seatDesc}>{i?.seatDesc}</div>))) : null
              }
              </div>
            </div>
          </div>
        </div>
        <div className={styles.tips}>
          <p>{TLang('温馨提示：', 'home', false, false, null)}</p>
          <p>
            {TLang('本订单为折扣票，', 'home', false, false, null)}
            <span>{TLang('不支持退票、改签、更换座位', 'home', false, false, null)}</span>
            {TLang('。请核实订单信息及折扣票规则，确认无误后下单', 'home', false, false, null)}
          </p>
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.cancle} onClick={() => setLevel2ConfirmModal(false)}>{TLang('取消', 'home', false, false, null)}</div>
        <div className={styles.confirm} onClick={() => confirmOrderHandle()}>{TLang('确认提交', 'home', false, false, null)}</div>
      </div>
    </Modal>
    <Modal
      visible={errorFlag}
      transparent
      maskClosable={false}
      onClose={() => { }}
      title={errorMsg}
      className="tout"
      wrapClassName="timeoutmldal"
      footer={[{
        text: TLang('确定', 'home', false, false, null), onPress: () => {
          setErrorFlag(false);
        }
      }]}
    />
    <Modal
      popup
      visible={refundInstructionsModal}
      animationType="slide-up"
      className="refundModal"
      onClose={() => setRefundInstructionsModal(false)}
    >
      <div className="refundInstructions">
        <div className="refundModalTitle">{TLang('退票须知', 'home', false, false, null)}</div>
        <div className="refundModalContent">
          <div className="refundModalItem">
            <div className="refundModalContent_smallTitle" onClick={() => { router.push({ pathname: '/refundExplain' }); setRefundInstructionsModal(false); }}>
              <img src={dataSource?.supportRefund ? supportRefundImg : errorRefundImg} />
              <span>{dataSource?.refundTagExplain}</span>
              <img src={refundRightArrow} />
            </div>
            <div className="refundModalContent_content">
              {dataSource?.refundRuleExplain?.map((item) => (
                <div key={item}>{item}</div>
              ))}
            </div>
          </div>
          <div className="refundModalItem">
            <div className="refundModalContent_smallTitle">
              <img src={dataSource?.supportChange ? supportRefundImg : errorRefundImg} />
              <span>{dataSource?.ticketChangeDesc}</span>
            </div>
            <div className="refundModalContent_content">{TLang('暂不支持改签服务', 'home', false, false, null)}</div>
          </div>
          <div className="refundModalItem">
            <div className="refundModalContent_smallTitle">
              <img src={refundTips} />
              <span>{TLang('特别提醒', 'home', false, false, null)}</span>
            </div>
            <div className="refundModalContent_content">
              <div>{TLang('仅限整单退票，不支持分座位退票', 'home', false, false, null)}</div>
              <div>{TLang('若支付金额小于退票服务费，不可退票', 'home', false, false, null)}</div>
              <div>{TLang('每人每月退票次数有限', 'home', false, false, null)}</div>
            </div>
          </div>
        </div>
        <div className="refundModalButton">
          <div className="refundModalButtonLine"></div>
          <div className="refundModalConfirmButton" onClick={() => setRefundInstructionsModal(false)}>{TLang('确定', 'home', false, false, null)}</div>
        </div>
      </div>
    </Modal>
  </div>;
};
const mapStateToProps = ({ initData }) => ({ unionConfig: initData.unionConfig });
export default connect(mapStateToProps)(OrderComfirm);



